<ls-breadcrumb currentLocation="Account Information"></ls-breadcrumb>
<ls-page [showPastDueBanner]="showPastDueBanner">
  <div class="o-layout">
    <div class="o-layout__block u-layout-full">
      <ls-account-subscription
        [account]="account$ | async"
        [accountInvoices]="accountInvoices$ | async"
        [hasManagerAccess]="hasManagerAccess$ | async"
        (requestNewPayment)="requestPaymentUrl($event)"
      ></ls-account-subscription>
    </div>

    <div class="o-layout__block u-layout-full">
      <ls-account-information
        [account]="account$ | async"
        [user]="user$ | async"
        [companySettings]="companySettings$ | async"
      ></ls-account-information>
    </div>

    <div class="o-layout__block u-layout-full">
      <div class="o-layout__item">
        <p class="u-color-gray u-align-center">
          <span i18n="Account|text for cancel account @@cancelAccount">
            Wanting to cancel your account? Before cancelling, make sure to
            export all of your data as you will no longer be able to access it
            after. If you have a paid subscription, billing will end after the
            account expiry date.
          </span>
          <span
            i18n="Account|text for cancel account contact @@cancelAccountContact"
          >
            To cancel your account, contact us
          </span>
          <a
            class="is-inline"
            href="https://www.lightspeedhq.com/contact/"
            target="_blank"
            title="contact page of Lightspeed"
            >here</a
          >.
        </p>
      </div>
    </div>
  </div>
</ls-page>
